import React from 'react';

const NotFoundPage: React.FC = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <h1 style={{ fontSize: '6rem', fontWeight: '700', color: '#61A1D4', margin: 0 }}>404</h1>
      <h2 style={{ fontSize: '2rem', fontWeight: '600', color: '#111827', marginTop: '1rem' }}>Page Not Found</h2>
      <p style={{ color: '#6B7280', marginTop: '1rem', maxWidth: '500px' }}>
        The page you're looking for doesn't exist or has been moved..
      </p>
      <a 
        href="/" 
        style={{
          marginTop: '2rem',
          padding: '0.75rem 2rem',
          backgroundColor: '#61A1D4',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '8px',
          fontWeight: '600',
          transition: 'all 0.2s'
        }}
      >
        Go Home
      </a>
    </div>
  );
};

export default NotFoundPage;
